<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        报警主机评估
      </div>
      <!-- <div class="common-page common-head-end">
                <i class="icon-tr-sign-out"></i>
      </div>-->
    </div>

    <div class="common-page common-body">
      <div class="common-page common-tool-bar">
        <el-date-picker
          v-model="params.time"
          type="month"
          :clearable="false"
          :editable="false"
          value-format="yyyy年MM月dd日 HH:mm:ss"
          placeholder="选择日期"
        >
        </el-date-picker>
        <div class="btn align-center ml10" @click="searchSubmit">
          <i class="icon-tr-search"></i>查询
        </div>
        <div class="btn ml10 align-center" @click="resetSearch">重置</div>
      </div>
      <div class="flex center">
        <div id="tab1" v-loading="loading"></div>
      </div>
      <div class="common-page common-list ml20" v-loading="loading">
        <el-table :data="list" class="">
          <el-table-column
            label="序号"
            prop="code"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="c_name"
            label="单位名称"
            align="center"
          ></el-table-column>
          <el-table-column prop="huoj" label="火警" align="center">
          </el-table-column>
          <el-table-column
            prop="guz"
            align="center"
            label="故障"
          ></el-table-column>
          <el-table-column
            prop="qid"
            align="center"
            label="启动"
          ></el-table-column>
          <el-table-column
            prop="fank"
            align="center"
            label="反馈"
          ></el-table-column>
          <el-table-column prop="jiang" label="监管" align="center">
          </el-table-column>
          <el-table-column prop="pingb" label="屏蔽" align="center">
          </el-table-column>
          <el-table-column prop="fuw" label="复位" align="center">
          </el-table-column>
          <el-table-column prop="other" label="其他" align="center">
          </el-table-column>
          <el-table-column prop="count" label="报警总数" align="center">
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="pageChange"
        :page-size="10"
        :total="total"
      ></el-pagination>
    </div>
    <!-- <el-dialog title="查询" :visible.sync="showDia" :close-on-click-modal="false">
       
        <el-form>
            <el-form-item label="选择日期" inline>
               
            </el-form-item>
        </el-form>

      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small">确定</el-button>
        <el-button @click="showDia=false" size="small">取消</el-button>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import echarts from "echarts";
import { getTime } from "../../api/common.js";

export default {
  data() {
    return {
      list: [],
      params: {
        time: "",
        endtime: "",
        pageNum: 1,
      },
      count: 0,
      value2: "",
      total: 0,
      loading: false,

      searchForm: this.$getForm("baojingSearch"),
      editData: {},
      remoteFuncs: {},
    };
  },
  created() {
    this.getTime();
  },
  computed: {},
  mounted() {},
  methods: {
    getTime() {
      // getTime().then(data=>{
      // let time = data.sysTime2.replace(/-/g, '/');
      let time = new Date(+new Date() + 8 * 3600 * 1000)
        .toJSON()
        .substr(0, 19)
        .replace("T", " ")
        .replace(/-/g, "/");

      let timeLine = new Date(time).getTime();
      this.params.time = new Date(timeLine).Format("yy年MM月01日 00:00:00");
      this.params.endtime = this.nextMonth(this.params.time);
      this.params.pageNum = 1;
      this.getList();
      // })
    },

    getNextMonth(date) {
      var arr = date.split("-");
      var year = arr[0]; //获取当前日期的年份
      var month = arr[1]; //获取当前日期的月份
      var day = arr[2]; //获取当前日期的日
      var days = new Date(year, month, 0);
      days = days.getDate(); //获取当前日期中的月的天数
      var year2 = year;
      var month2 = parseInt(month) + 1;
      if (month2 == 13) {
        year2 = parseInt(year2) + 1;
        month2 = 1;
      }
      var day2 = day;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();
      if (day2 > days2) {
        day2 = days2;
      }
      if (month2 < 10) {
        month2 = "0" + month2;
      }

      var t2 = year2 + "年" + month2 + "月" + day2 + "日" + " 00:00:00";
      return t2;
    },
    changtime(time) {
      return time.substring(0, 10);
    },
    makeChart() {
      var xArr = [];
      var yArr = [];
      if (this.list.length) {
        this.list.map((item, index) => {
          xArr.push(item.c_name);
          yArr.push(item.count);
        });
      }
      var option = {
        color: ["#3398DB"],
        //   title: {
        //     text: "Beijing AQI",

        //   },
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          data: xArr,
          name: "单位名称",
          nameTextStyle: {
            fontSize: 18,
            fontFamily: "Arial",
            fontWeight: "bold",
          },
        },
        yAxis: {
          splitLine: {
            show: false,
          },
          splitArea: {
            show: false,
          },
          name: "报警总数",
          nameTextStyle: {
            fontSize: 18,
            fontFamily: "Arial",
            fontWeight: "bold",
          },
          //  max: 10000,
          // scale: false,
          // splitNumber: 10,
          // minInterval: 0
        },
        dataZoom: [
          {
            start: 2,
            type: "inside",
          },
          {
            type: "slider",
            start: 2,
          },
        ],
        series: {
          name: "报警总数",
          type: "bar",
          data: yArr,
          large: true,
        },
      };
      echarts.init(document.getElementById("tab1")).setOption(option);
      this.loading = false;
    },
    getList() {
      this.loading = true;
      this.$post("/monitor/reportcall", this.params).then((res) => {
        this.list = res.list;
        this.total = res.count;
        this.makeChart();
      });
    },
    pageChange(val) {
      this.params.pageNum = val;
      this.getList();
    },
    searchSubmit() {
      this.params.endtime = this.nextMonth(this.params.time);
      this.getList();
    },
    nextMonth(a) {
      var arr1 = a.split(" ");

      var date = arr1[0].replace(/[年,月]/g, "-");
      date = date.replace(/日/, "");
      var arr = date.split("-");
      var year = arr[0]; //获取当前日期的年份
      var month = arr[1]; //获取当前日期的月份
      var day = arr[2]; //获取当前日期的日
      var days = new Date(year, month, 0);
      days = days.getDate(); //获取当前日期中的月的天数
      var year2 = year;
      var month2 = parseInt(month) + 1;
      if (month2 == 13) {
        year2 = parseInt(year2) + 1;
        month2 = 1;
      }
      var day2 = day;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();
      if (day2 > days2) {
        day2 = days2;
      }
      if (month2 < 10) {
        month2 = "0" + month2;
      }
      var t2 = year2 + "年" + month2 + "月" + day2 + "日" + " 00:00:00";
      return t2;
    },
    resetSearch() {
      this.getTime();
      //   this.params = { page: 1, c_type:"", ...this.$refs.searchForm.models };
      //   this.getList();
    },
  },
};
</script>

<style scoped>
#tab1 {
  width: 70%;
  height: 500px;
}
</style>
